var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"footer",style:({
    'background-color': _vm.footerBackground,
    color: _vm.footerColor
  })},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.footer)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }